import { render } from "./PlatformIcon.vue?vue&type=template&id=587ce01a&ts=true"
import script from "./PlatformIcon.vue?vue&type=script&lang=ts"
export * from "./PlatformIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
